import styled from "styled-components";
import Heading from "../../atoms/Heading";

export const Wrap = styled.div``;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 48px;
  padding-top: 0;

  @media (min-width: 990px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const HeaderContent = styled.div`
  position: relative;
  margin-bottom: 16px;

  p {
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
  }
`;

export const Title = styled(Heading)`
  margin: 0 0 16px 0;
  padding: 0;
  padding-left: 40px;
  font-size: 24px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.8px;
  color: var(--color-heading);

  @media (min-width: 990px) {
    padding-left: 0;
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  background: none;
  padding: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg {
    display: block;
  }

  @media (min-width: 990px) {
    top: 0;
    left: -40px;
  }
`;

export const BackLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  background: none;
  padding: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg {
    display: block;
  }

  @media (min-width: 990px) {
    top: 0;
    left: -40px;
  }
`;

export const CountGeneral = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  border: 1px solid #e6e6e6;
  border-radius: 3px;

  .edit-quantity__count {
    padding: 0 6px;
    border-right: 1px solid #e6e6e6;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.8px;
    color: var(--color-primary);
  }

  .edit-quantity__content {
    padding: 0 6px;
    font-size: 16px;

    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
  }
`;

export const Body = styled.div`
  .meal-controls {
    align-items: center;
    input {
      width: 94px;
      margin: 0;
      font-size: 48px;

      line-height: 0.33;
    }

    button {
      height: 44px;
      width: 44px;

      svg {
        height: 44px;
        width: 44px;
      }
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Quantificator = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const QuantificatorItem = styled.div`
  width: 100%;
  border-radius: 8px;
  border: solid 1px rgba(151, 151, 151, 0.16);
  padding: 2px;
  padding-bottom: 20px;
  margin: 0px 5px 30px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    width: calc(33.3333% - 10px);
    margin-bottom: 0;
  }
`;
export const QuantificatorItemImageWrap = styled.div`
  clip-path: polygon(0 0, 100% 0, 100% 90%, 0 100%);

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
    border-radius: 4px 4px 0 0;
  }
`;

export const QuantificatorItemTitle = styled.h3`
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 32px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.51px;
  text-align: center;
`;

export const QuantificatorItemPrice = styled.p`
  font-size: 16px;

  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #5f645f;
  text-align: center;
`;

export const Button = styled.button`
  position: relative;
  margin-top: 20px;
  margin-bottom: 16px;
  background: var(--color-primary);
  padding: 12px 40px;
  border: 1px solid var(--color-primary);
  border-radius: 30px;
  color: #fff;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: 0.6px;
  text-align: center;
  text-transform: uppercase;
  outline: none;
  box-shadow: none;
  cursor: pointer;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &:hover:not(:disabled) {
    background-color: #fff;
    color: var(--color-primary);
  }

  @keyframes ld-spin {
    0% {
      animation-timing-function: cubic-bezier(0.5856, 0.0703, 0.4143, 0.9297);
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin: -10px;
    opacity: 0;
    z-index: -1;
    transition: all 0.3s;
    transition-timing-function: ease-in;
    animation: ld-spin 1s infinite linear;

    &::after {
      content: " ";
      display: block;
      width: 40px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 50%;
      border: 5px solid #fff;
      border-left-color: transparent;
      transform-origin: 0 0;
      transform: translateZ(0) scale(0.5);
      backface-visibility: hidden;
    }
  }

  &.loading {
    span {
      opacity: 1;
      z-index: auto;
      visibility: visible;
    }

    b {
      opacity: 0.3;
    }
  }
`;

export const ValidationMessage = styled.p`
  color: #d20000;
  text-align: center;
`;
